// 配置文件

// var commonAddress4 = process.env.API_HOST_V4;
// var commonAddress4S = process.env.API_HOST_V40S;
// var epVisitUrl = process.env.ENTERPRISE_HOST;

//直接读取 不参与编译的配置
var commonAddress4 = API_HOST_V4;
var commonAddress4S = API_HOST_V40S;
var epVisitUrl = ENTERPRISE_HOST;

/** 各环境共用 */
var commonAddress = commonAddress4 + '/v4' // 4.0接口请求公共地址域名
var address = commonAddress + '/admin'  // 4.0平台级平台接口请求地址域名
var epAutoLoginUrl = commonAddress+ '/Client/login/doLogin' // 企业平台自动登录请求地址

// 公共头部信息
var commomHeaders = {
    'Content-Type': 'application/json'
}

let naviMapList = {
    '模块管理':'modulManage',
    '第三方应用':'thirdApplication'
}

export {
    address,
    commonAddress,
    commonAddress4S,
    epAutoLoginUrl,
    epVisitUrl,
    commomHeaders,
    naviMapList,
}


//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = wAX/
// module chunks = 1